<script>
import store from '@state/store'
import PostForm from '@router/components/post-form.vue'
import { authComputed } from '@state/helpers'
import EarnedPoints from '@kynd-points/components/earned-points.vue'

export default {
  name: 'PostFormWrapper',
  components: {
    PostForm,
    EarnedPoints,
  },
  props: {
    companyId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      refreshPostForm: false,
      showEarnedPoints: false,
      loadingMore: false,
      lastPostPoints: 0,
    }
  },
  computed: {
    ...authComputed,
    shouldRefreshPostForm() {
      return this.refreshPostForm
    },
  },
  methods: {
    postStatusUpdate(params) {
      store
        .dispatch('companies/postNewStatusUpdate', {
          text: params.text,
          hours: params.hours,
          kyndCode: params.kyndCode,
          amount: params.amount,
          type: params.postType,
          kyndnessType: params.kyndnessType,
          userId: this.currentUser.id,
          updatableId: this.companyId,
          updatableType: 'company',
          postAnonymous: params.postAnonymous,
          challenge: params.challenge,
          giver: params.giver,
          organization: params.organization,
          causes: params.causes,
          friends: params.friends,
          tags: params.tags,
          images: params.images,
          videoUrl: params.videoUrl,
        })
        .then((newPost) => {
          // reset and hide form
          this.refreshPostForm = newPost.id
          // show kynd points
          this.lastPostPoints = newPost.points
          this.showEarnedPoints = true
        })
        .catch(() => {})
    },
    closePointsModal() {
      this.showEarnedPoints = false
    },
  },
}
</script>

<template>
  <div>
    <PostForm
      :key="shouldRefreshPostForm"
      :company-id="companyId"
      @post-status-update="postStatusUpdate"
    >
    </PostForm>
    <EarnedPoints
      v-if="showEarnedPoints"
      :company-id="companyId"
      :post-points="lastPostPoints"
      :total-points="currentUser.funds"
      @close="closePointsModal"
    ></EarnedPoints>
  </div>
</template>
